import React from 'react'
import PropTypes from 'prop-types'
import './NavBar.scss'
import MainNavBar from './MainNavBar'
import AltNavBar from './AltNavBar'

const NavBar = props => {
  const { location, user, navProps } = props
  const token = location?.query?.token
  const newToken = token || user.token
  if (newToken !== user.token) return null
  return (
    <div>
      <div className='navbar-placeholder' />
      {navProps ? <AltNavBar {...props} /> : <MainNavBar {...props} />}
    </div>
  )
}

export default NavBar

NavBar.propTypes = {
  study: PropTypes.object,
  studies: PropTypes.array,
  location: PropTypes.object,
  modalProps: PropTypes.object,
  user: PropTypes.object,
  onLogout: PropTypes.func,
  navProps: PropTypes.object
}
